/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Notifications_initialViewer = {|
  +conversations?: ?{|
    +metadata: ?{|
      +lastUnreadMessageDate: ?string;
      +totalUnreadConversationCount: ?number;
    |};
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Notifications_initialViewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ActivityFeed_tradeRewardEnabled",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": "showUnreadOnly",
              "type": "String"
            }
          ],
          "concreteType": "ConversationConnection",
          "name": "conversations",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "ConversationMetadata",
              "name": "metadata",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "lastUnreadMessageDate",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "totalUnreadConversationCount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "conversations{\"filter\":\"showUnreadOnly\"}"
        }
      ]
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
